import * as _m from '@/models';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'react-router-dom';
import { lazy } from 'react';

type Props = {
  channel_post: _m.ChannelPost;
};

export const RelCreators = ({ channel_post }: Props) => {
  if (channel_post.creators.length == 0) {
    return <div className="covers"></div>;
  }

  return (
    <div className="covers">
      <div className="section-title sm">女の子プロフィール</div>
      <Swiper slidesPerView={'auto'} centeredSlides={false} lazy={true}>
        {channel_post.creators.map((c) => {
          const gtmClickValue = `creator_click:${c.id}`;

          return (
            <SwiperSlide key={`${channel_post.id}_${c.id}`} className="swiper-slide icon-only">
              <Link
                key={`${channel_post.id}_${c.id}`}
                to={c.url}
                className="swiper-slide icon-only"
                target="_blank"
                data-gtm-click={gtmClickValue}
              >
                <img
                  src={c.icon_url}
                  className="icon swiper-lazy"
                  loading={'lazy'}
                  width={80}
                  height={80}
                  data-gtm-click={gtmClickValue}
                />
                <div className="name" data-gtm-click={gtmClickValue}>
                  {c.name}
                </div>

                {/*<div className="wrapper" data-gtm-click={gtmClickValue}>*/}
                {/*  <img src={c.profile_image_url} className="cover" loading={'lazy'} data-gtm-click={gtmClickValue} />*/}
                {/*  <img src={c.icon_url} className="icon" loading={'lazy'} data-gtm-click={gtmClickValue} />*/}
                {/*</div>*/}
                {/*<div className="content">*/}
                {/*  <div className="name">{c.name}</div>*/}
                {/*  <div className="count"></div>*/}
                {/*</div>*/}
              </Link>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};
